<div class="dashboard-panel"><app-timesheet-table
  [selection]="selection"
  (select)="onSelectionChange($event)">
</app-timesheet-table>

    
</div>